import React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  button: {
    position: 'relative',
    color: '#abcdef',
    transform: 'translateY(-30%)',
    backgroundColor: 'rgba(0,0,0,0.4)',
    borderRadius: '50%'
  },
  icon: {
    color: '#fff'
  }
}));


function ScrollButton(props) {
  const classes = useStyles();

  var { icon, end, onClick } = props;
  if (!end) end = 'left';

  return (
    <div
      className={classes.root}
      style={{ [end]: 0 }}
    >
      <div className={classes.button}>
        <IconButton
          className={classes.icon}
          size='small'
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </div>
    </div>
  );
}

ScrollButton.propTypes = {
  icon: PropTypes.element.isRequired,
  end: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default ScrollButton;
